// extracted by mini-css-extract-plugin
export default {"vf-blockquote":"Publication_style__vf-blockquote___ff"};